import React, { useState, useRef, useEffect, useContext } from 'react'
import PropTypes from 'prop-types'
import { makeStyles } from '@material-ui/core/styles'
// import Box from '@material-ui/core/Box'
import Collapse from '@material-ui/core/Collapse'
// import IconButton from '@material-ui/core/IconButton'
import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import TableCell from '@material-ui/core/TableCell'
import TableContainer from '@material-ui/core/TableContainer'
import TableHead from '@material-ui/core/TableHead'
import TableRow from '@material-ui/core/TableRow'
// import Typography from '@material-ui/core/Typography'
import Paper from '@material-ui/core/Paper'
import { ExpandMore, ExpandLess } from '@material-ui/icons'
import PropertyDetails from './PropertyDetails/PropertyDetails'
// import PropertyUnitMix from '../PropertyUnitMix/PropertyUnitMix'
import listContext from '../../Common/context/context'
import allColumns from './propertyListColumns'
import floorPlanColumns from './floorPlanColumns'
import RemovePropertyFromList from './RemovePropertyFromList/RemovePropertyFromList'
import ExcludePropertyFromList from './ExcludePropertyFromList/ExcludePropertyFromList'
import FloorPlanRow from './FloorPlanRow/FloorPlanRow'
import {
    getFormattedNumber, sortArray, getTotalAvgForSummaryComps, valueFormatter, updatePropertyRank,
    getSummaryColumnsList, getUnitMixSource, getFloorPlanColumns, getRentViewSettings, unitsTotalFormula, isStudentHousingList
} from '../Utility/PropertyListUtility'
import SelectUnitMixSource from '../PropertyUnitMix/SelectUnitMixSource/SelectUnitMixSource'
import { formatDate } from '../../PropertySearch/Utility/Utility'
import { displayDateFormat } from '../../PropertySearch/Utility/Utility'

const useRowStyles = makeStyles({
    root: {
        '& > *': {
            borderBottom: 'unset',
        },
    },
    borderTopUnset: {
        '& > *': {
            borderTop: 'unset',
        },
    },
    borderSpacing: {
        '& > *': {
            borderCollapse: 'separate',
            borderSpacing: '0px 25px',
        },
    },
})

const getAlignment = type => {
    let returnVal = 'left'
    if (type !== 'text') {
        returnVal = 'right'
    }

    return returnVal
}


let subjectPropertyId = []
const Row = props => {
    const [source, setSource] = useState(props.row.sourcePreference || "")
    const { row, showAllDetails, columnsList, compType, rowIndex, deleteList, setDeleteList, isStudentHousingProperty } = props
    const { data, omniViewPropertyId, excludeProperty } = row
    const omniviewproperty = data.omniviewproperty[0]
    // const { savedSearch } = useContext(searchContext)
    const { propertyList } = useContext(listContext)
    let lstOmniviewtransactionhistory = [...data.omniviewtransactionhistory]
    lstOmniviewtransactionhistory = lstOmniviewtransactionhistory.filter(x => x.transactionType && x.transactionType.toLowerCase() === 'sale')
    lstOmniviewtransactionhistory = [...sortArray(lstOmniviewtransactionhistory, 'saleDate', 'desc')]
    const omniviewtransactionhistory = lstOmniviewtransactionhistory.length ? lstOmniviewtransactionhistory[0] : {}

    const [open, setOpen] = React.useState(false)
    const classes = useRowStyles()
    const detailsRef = useRef(null)
    const getSourcePreference = () => {

        let returnVal = ''

        if (data && data.omniviewpropertyrent) {
            returnVal = getUnitMixSource({ 'compsList': [row] }, row.omniViewPropertyId)
        }

        return returnVal
    }

    useEffect(() => {
        if (data && data.omniviewpropertyrent) {
            let newSource = getSourcePreference()
            setSource(newSource)
        }
    }, [row])

    useEffect(() => {
        setOpen(showAllDetails)
    }, [showAllDetails])

    const getFieldValue = rowParam => {
        let returnVal = '-'
        try {

            if (rowParam.dataObj === 'omniviewtransactionhistory' && omniviewtransactionhistory[rowParam.fieldName]) {
                returnVal = omniviewtransactionhistory[rowParam.fieldName]
                if (rowParam.fieldName && (rowParam.fieldName === 'transactionHistoryPricePerUnit' || rowParam.fieldName === 'salePrice')) {
                    returnVal = parseInt(returnVal) ? parseInt(returnVal) : returnVal
                }
            }
            if (rowParam.dataObj === 'omniviewproperty' && omniviewproperty[rowParam.fieldName]) {
                returnVal = omniviewproperty[rowParam.fieldName]
            }

            if (rowParam.dataObj === 'omniviewproperty' && rowParam.fieldName === 'yearBuilt' && (omniviewproperty['yearBuilt'] || omniviewproperty['yearRenovated'])) {
                let built = omniviewproperty[rowParam.fieldName] ? omniviewproperty[rowParam.fieldName] : '-'
                let reno = omniviewproperty['yearRenovated'] ? omniviewproperty['yearRenovated'] : '-'
                if (propertyList.showReno) {
                    returnVal = `${built} | ${reno}`
                } else {
                    returnVal = built
                }

            }

            if (rowParam.fieldName !== 'yearBuilt' && rowParam.type === 'date' && returnVal && returnVal !== '-' && returnVal.length !== 4) {
                if (rowParam.fieldName === 'saleDate') { //sourceLastModifiedDate
                    // returnVal = formatDate(returnVal)
                    returnVal = displayDateFormat(returnVal)
                } else {
                    var options = { year: 'numeric', month: 'short', day: 'numeric' }
                    returnVal = new Intl.DateTimeFormat('en-US', options).format(new Date(returnVal))
                }
            }

            returnVal = returnVal.toString()

            if (returnVal && returnVal !== '-') {

                switch (rowParam.type) {
                    case 'number':
                        returnVal = getFormattedNumber(returnVal)
                        break
                    case 'percent':
                        // returnVal = getFormattedNumber(returnVal, '%')
                        if (returnVal.includes('.')) {
                            returnVal = getFormattedNumber(returnVal, '%', '2', '2')
                        } else {
                            returnVal = getFormattedNumber(returnVal, '%')
                        }
                        break
                    case 'currency':
                        if (returnVal.includes('.')) {
                            returnVal = getFormattedNumber(returnVal, '$', '2', '2')
                        } else {
                            returnVal = getFormattedNumber(returnVal, '$')
                        }
                        break
                    default: break
                }
            }
        } catch (error) {
            console.log('error in getFieldValue in Propertylisttable::', error)
        }

        return returnVal
    }

    const getAddress = () => {
        let address = ''

        try {
            address = `${omniviewproperty.addressLine1} ${omniviewproperty.city ? omniviewproperty.city : ''}, ${omniviewproperty.state ? omniviewproperty.state : ''}, ${omniviewproperty.zipCode ? omniviewproperty.zipCode : ''}`
            address = address.replace(',,', ',')
            address = address.replace(', ,', ',')
        } catch (error) {

        }
        return address
    }

    if (propertyList) {
        subjectPropertyId = []
        for (let i = 0; i < propertyList.compsList.length; i++) {
            if (propertyList.compsList[i].isSubjectProperty === true) {
                if (subjectPropertyId.indexOf(propertyList.compsList[i].omniViewPropertyId) === -1) {
                    subjectPropertyId.push(propertyList.compsList[i].omniViewPropertyId)
                }
            }
        }
    }

    const checkSubjectPropertyId = (omniViewPropertyId) => {
        let value = false;
        for (let i = 0; i < subjectPropertyId.length; i++) {
            if (subjectPropertyId[i] === omniViewPropertyId) {
                return true;
            }
            else value = false;
        }
        return value;
    }



    const handleClick = (event, omniViewPropertyId) => {
        let index;
        let checkedValue = event.target.checked

        if (checkedValue === true) {
            if (deleteList.indexOf(omniViewPropertyId) === -1) {
                setDeleteList([...deleteList, omniViewPropertyId])
            }
        }
        else {
            index = deleteList.indexOf(omniViewPropertyId);
            let tempDeleteList = [...deleteList]
            if (index > -1) {
                tempDeleteList.splice(index, 1);
                setDeleteList(tempDeleteList)
            }
        }
    }

    return (
        <React.Fragment>
            <TableRow id={omniViewPropertyId}
                draggable={isNaN(rowIndex) ? false : true}
                className={` drag-row ${classes.borderTopUnset}`}  >
                {/* <TableCell className="sticky-left" align="center">
                    {isNaN(rowIndex) ?
                        <span className="bg-gray-80 text-white p-3 rounded-1">{rowIndex}</span>
                        : <span className="bg-gray-10 p-3 px-4 rounded-1">{rowIndex}</span>}
                    </TableCell> */}
                {columnsList.map(row => (
                    <TableCell className={`text-1 ${row.fieldName === 'propertyName' ? 'sticky-left' : ''} `} align={getAlignment(row.type)}>
                        <div className={`flex flex-col ${row.fieldName === 'propertyName' ? 'border-r-1 border-base ' : ''}`}>
                            {row.fieldName === 'propertyName' ?
                                <>
                                    <div className="flex flex-row">
                                        <div className="mr-5 mt-2">
                                            <span>
                                                <input type="checkbox" data-testid={`test-chk-select-${omniViewPropertyId}`}
                                                    disabled={checkSubjectPropertyId(omniViewPropertyId)}
                                                    onClick={(event) => handleClick(event, omniViewPropertyId)} value={omniViewPropertyId}
                                                />
                                            </span>
                                        </div>
                                        <div className="mr-5 mt-1">
                                            {isNaN(rowIndex) ?
                                                <span className="bg-gray-80 text-white p-3 mr-3 rounded-1">{rowIndex}</span>
                                                : <span className=" p-3 px-4 mr-3 rounded-1">{rowIndex}</span>}
                                        </div>
                                        <div className="pr-4 flex flex-col">
                                            <span className={`${excludeProperty ? 'text-disabled' : ''} truncate`} >
                                                {excludeProperty ? <span className="text-1">{getFieldValue(row)}</span> : <a href={`${window.REACT_GLOBAL_CONFIG.SF_URL}${omniViewPropertyId}`} target="_blank" rel="noopener noreferrer">{getFieldValue(row)}</a>}
                                            </span>
                                            <span className={`truncate ${excludeProperty ? 'text-disabled' : 'text-1 text-muted truncate'} `}>{getAddress()}</span>
                                        </div>
                                    </div>
                                </>
                                :
                                <>
                                    {row.fieldName === 'source' ?
                                        <span className="">
                                            <SelectUnitMixSource source={source} setSource={setSource} propertyId={omniViewPropertyId}></SelectUnitMixSource>
                                        </span>
                                        :
                                        <span className={`truncate ${excludeProperty ? 'text-disabled' : ''}`}>{getFieldValue(row)}</span>}
                                    <span className={`truncate ${excludeProperty ? 'text-disabled' : 'text-1 text-muted truncate'} `}>
                                        {row.fieldName === 'yearBuilt' ?
                                            propertyList.showReno ? 'Built | Reno' : 'Built'
                                            : row.fieldName === 'source' ? '' : row.label}
                                        {/* {row.label} */}
                                    </span>
                                </>
                            }
                        </div>
                    </TableCell>
                ))}
                {/* <TableCell component="th" scope="row">
                    {omniviewproperty.name}
                </TableCell>
                <TableCell align="right">{row.calories}</TableCell> */}
                <TableCell className='sticky-right'>
                    <div className="space-x-4 space-x-reverse border-l-1 border-base pl-4 flex flex-row-reverse">
                        <button title="Expand" data-testid={`test-btn-show-details-${getFieldValue('propertyNameSearch')}`} ref={detailsRef} aria-label="expand row" className={`btn btn-sm ${open ? 'text-primary' : ''}`} onClick={() => setOpen(!open)}>
                            {open ? <ExpandLess fontSize="small" /> : <ExpandMore fontSize="small" />}
                        </button>
                        {!row.isSubjectProperty ?
                            <RemovePropertyFromList propertyId={omniViewPropertyId} omniViewPropertyListId={propertyList.omniViewPropertyListId} polarisPropertySearchCriteriaId={propertyList.polarisPropertySearchCriteriaId} />
                            : null}
                        {!row.isSubjectProperty ?
                            <ExcludePropertyFromList propertyId={omniViewPropertyId} />
                            : null}
                    </div>
                </TableCell>
            </TableRow>
            <TableRow className={` ${open ? '' : classes.root}`}>
                <TableCell style={{ padding: 0, }} colSpan={columnsList.length + 1}>
                    <Collapse in={open} timeout="auto" unmountOnExit>
                        <PropertyDetails row={row} compType={compType} source={source} setSource={setSource} isStudentHousingProperty={isStudentHousingProperty}></PropertyDetails>
                        {/* <PropertyUnitMix row={row}></PropertyUnitMix> */}
                    </Collapse>
                </TableCell>
            </TableRow>
        </React.Fragment >
    )
}

Row.propTypes = {
    row: PropTypes.any,
    showAllDetails: PropTypes.any,
    columnsList: PropTypes.any,
    compType: PropTypes.any,
    rowIndex: PropTypes.any,
}

function usePrevious(value) {
    const ref = useRef();
    useEffect(() => {
        ref.current = value;
    });
    return ref.current;
}

// export default function CollapsibleTable() {
const CollapsibleTable = props => {

    const { propertyList, setPropertyList } = useContext(listContext)
    const { showAllDetails, view, deleteList, setDeleteList } = props
    const [propertyListView, setPropertyListView] = useState(view ? view : 'overview')
    const [columnsList, setColumnsList] = useState([])
    const totalAvgs = getTotalAvgForSummaryComps(propertyList)
    const [draggedRowId, setDraggedRowId] = useState('')
    const [rowtoDrop, setRowtoDrop] = useState('')
    const [floorplanSummaryValue, setFloorplanSummaryValue] = useState([])
    const prevRowtoDrop = usePrevious(rowtoDrop)

    const [FPUnitTypes, setFPUnitTypes] = useState([])
    const [propertyTypesArray, setPropertyTypesArray] = useState([])
    const [filteredColumnsList, setFilteredColumnsList] = useState([])

    const [isStudentHousingProperty, setIsStudentHousingProperty] = useState(isStudentHousingList(propertyList));
    useEffect(() => {
        if (propertyList) {

            if (propertyListView === 'floorplan') {
                setFloorPlanUnitTypes()
            }
            if (propertyListView === 'overview') {
              setColumnsList(getSummaryColumnsList(propertyList, allColumns))
            }
        }
    }, [propertyList.compType])

    useEffect(() => {
        if (FPUnitTypes.length > 0) {
            initializeFloorPlanColumns()
        }
    }, [propertyList.compType, FPUnitTypes])

    useEffect(() => {
        if (propertyList.compType !== 'sales' && propertyListView === 'floorplan') {
            calcFloorPlanSummary()
        }
    }, [propertyList, columnsList])

    useEffect(() => {
        if (propertyList.compType !== 'sales' && propertyListView === 'floorplan') {
            updateFloorPlanColumnsList()
        }
        setIsStudentHousingProperty(isStudentHousingList(propertyList));
    }, [propertyList, columnsList, propertyTypesArray])

    // function addColumns(baseColumn, _FPUnitType) {
    //     let newcColumns = []

    //     const newArr = baseColumn.map(v => ({ ...v, unitType: _FPUnitType }))

    //     // console.log('columns = ', _FPUnitType, ' = ', newArr)

    //     return newArr
    // }

    const initializeFloorPlanColumns = () => {
        let columns = []

        const baseColumns = getFloorPlanColumns(propertyList, floorPlanColumns)
        // let baseColumnsCount = baseColumns.length
        // console.log('FPUnitTypes = ', FPUnitTypes)

        for (const element of FPUnitTypes) {
            let newcColumns = baseColumns.map(v => ({ ...v, unitType: element }))
            columns = [...columns, ...newcColumns]
        }

        // console.log('columns = ', columns)
        columns.unshift({ label: 'Property Name', summaryFieldName: '', summaryHeader: '', fieldName: 'propertyName', sortable: false, type: 'text', dataObj: 'omniviewproperty' })
        columns.push({ label: 'Updated', summaryFieldName: '-', summaryHeader: '-', fieldName: 'sourceLastModifiedDate', sortable: false, type: 'date', dataObj: 'omniviewproperty' })
        columns.push({ label: 'Source', summaryFieldName: '-', summaryHeader: '-', fieldName: 'source', sortable: false, type: 'text', dataObj: 'omniviewproperty' })
        setColumnsList(columns)
    }

    const setFloorPlanUnitTypes = () => {
        let unitTypes = []
        for (let item of propertyList.compsList) {
            let omniViewPropertyId = item.omniViewPropertyId

            let propertyrents = []
            let source = getUnitMixSource(propertyList, omniViewPropertyId)
            if (source && item.data.omniviewpropertyrent) {
                propertyrents = item.data.omniviewpropertyrent.filter(x => x.source.toLowerCase() === source.toLowerCase())
                // console.log(omniViewPropertyId, ' = ', source, ' = ', propertyrents)
            }
            for (let propertyrent of propertyrents) {
                let currentUnitType = propertyrent.unitType
                currentUnitType = currentUnitType.split('/')[0]
                currentUnitType = currentUnitType.trim()
                if (!unitTypes.find(unitType => unitType === currentUnitType)) {
                    unitTypes.push(currentUnitType)
                }

            }
        }

        let studioExist = unitTypes.findIndex(e => e.toLowerCase() === 'studio')
        unitTypes = unitTypes.filter(e => e.toLowerCase() !== 'studio')

        unitTypes = unitTypes.sort()

        if (studioExist !== -1) {
            unitTypes.unshift('Studio')

        }

        setFPUnitTypes(unitTypes)

    }

    useEffect(() => {
        if (rowtoDrop && prevRowtoDrop !== rowtoDrop) {
            updatePropertyListRank()
        }
    }, [rowtoDrop])

    const getRowIndex = (row, index) => {
        let returnVal = ''
        const subjectCount = propertyList.compsList.filter(x => x.isSubjectProperty).length

        if (row.isSubjectProperty) {
            returnVal = subjectCount !== 1 ? `S${index + 1}` : 'S '
        } else {
            returnVal = index - subjectCount + 1
        }

        return returnVal
    }


    const getCompsList = () => {

        let returnVal = []
        if (propertyList && propertyList.compsList) {
            returnVal = [...propertyList.compsList]
        }

        return returnVal
    }

    const getCompType = () => {

        let returnVal = 'rent'
        if (propertyList && propertyList.compType) {
            returnVal = propertyList.compType.toLowerCase()
        }

        return returnVal
    }

    const getFieldValue = (fieldCol) => {

        let returnVal = '-'
        // let compType = getCompType().charAt(0).toUpperCase() + s.slice(1)
        try {

            returnVal = totalAvgs[getCompType()][fieldCol.summaryFieldName]

        } catch (error) {
            console.log("error in getFieldValue ::: " + error.message)
        }

        if (fieldCol.summaryFieldName === 'occupancy') {
            returnVal = (returnVal).toFixed()
        }
        returnVal = valueFormatter(returnVal, fieldCol.type)
        return returnVal

    }

    // 1. Define Function which adds all the required event listeners
    function addDragEvents(element) {
        element.addEventListener("dragstart", dragCell);
        element.addEventListener("dragover", allowDrop);
        element.addEventListener("drop", dropCell);
    }

    let cells = document.getElementsByClassName('drag-row');
    for (let cell of cells) {
        addDragEvents(cell);
    }

    function dragCell(e) {
        try {
            let draggedRow = e.target.closest("tr");
            setDraggedRowId(draggedRow.id)

        } catch (error) {
            console.log('dragCell === ', error)
        }
    }

    function allowDrop(e) {
        e.preventDefault();
        e.stopPropagation()
    }

    function dropCell(e) {

        try {
            e.preventDefault()

            let rowToDrop = e.target.closest('tr')

            let droppedProperty = propertyList.compsList.filter(x => x.omniViewPropertyId === rowToDrop.id)[0]

            if (droppedProperty.isSubjectProperty) {
                return
            }

            setRowtoDrop(rowToDrop.id)

        } catch (error) {
            console.log('dropCell===', error)
        }

    }

    const updatePropertyListRank = async () => {

        try {
            let draggedPropertyId = draggedRowId

            let compsListNewRank = []

            let rank = 0

            let droppedProperty = propertyList.compsList.filter(x => x.omniViewPropertyId === rowtoDrop)[0]

            let targetIndex = droppedProperty.rank - 1

            propertyList.compsList.forEach(element => {
                //this will update the rank of the property which came after drop location
                if (rank === targetIndex) {
                    rank += 1
                }

                let listData = { ...element }
                listData.rank = element.omniViewPropertyId === draggedPropertyId ? +targetIndex + 1 : +rank + 1
                compsListNewRank.push(listData)
                rank = element.omniViewPropertyId === draggedPropertyId ? rank : +rank + 1
            })
            compsListNewRank = sortArray(compsListNewRank, 'rank', 'asc')
            // setNewCompsList(compsListNewRank)

            let newPropertyList = { ...propertyList }
            newPropertyList.compsList = [...compsListNewRank]
            setPropertyList(newPropertyList)

            let compsList = []
            compsListNewRank.forEach(element => {
                compsList.push({
                    omniViewCompsListId: element.omniViewCompsListId,
                    isSubjectProperty: element.isSubjectProperty,
                    omniViewPropertyId: element.omniViewPropertyId,
                    rank: element.rank
                })
            })

            if (compsList.length > 0) {
                await updatePropertyRank({
                    compsList: compsList,
                    omniViewPropertyListId: propertyList.omniViewPropertyListId,
                    polarisPropertySearchCriteriaId: propertyList.polarisPropertySearchCriteriaId
                })
            }

            setRowtoDrop('')
        } catch (error) {
            console.log('updatePropertyListRank = ', error)
        }
    }

    const getColSpanForFP = () => {
        let returnVal = 4
        const uniquedata = Array.from(new Set(propertyTypesArray))
        if (uniquedata.length >= 1 && uniquedata.includes('Student Housing')) {
            returnVal = 5
        }

        let viewSettings = getRentViewSettings(propertyList)
        if (viewSettings.includes('market rent') && viewSettings.includes('effective rent')) {
            returnVal = 6
        }
        return returnVal
    }

    const getFloorPlanSummaryValue = column => {
        let returnVal

        try {
            if (column.label !== "Property Name" && column.label !== "mixedWTAvg" && floorplanSummaryValue.length > 0) {
                let index = floorplanSummaryValue.findIndex(x => x.unitType === column.unitType)
                returnVal = floorplanSummaryValue[index][column.summaryFieldName]
                returnVal = valueFormatter(returnVal, column.type)
            } else if (column.label === "mixedWTAvg") {
                returnVal = '-';
            }

        } catch (error) {
            console.log('error in getFloorPlanSummaryValue = ', column)
        }

        return returnVal
    }

    const updateFloorPlanColumnsList = () => {
        let modifiedColumnList = []
        const uniquePropertyTypes = Array.from(new Set(propertyTypesArray))
        columnsList.forEach(column => {
            if (uniquePropertyTypes.length === 1 && uniquePropertyTypes[0] === 'Student Housing' && column.fieldName !== 'unitMarketRent' && column.fieldName !== 'nonbeds') {
                modifiedColumnList.push(column)
            } else if (uniquePropertyTypes.length > 0 && !(uniquePropertyTypes.includes('Student Housing')) && (column.fieldName !== 'mrBed' && column.fieldName !== 'beds' && column.fieldName !== 'nonbeds')) {
                modifiedColumnList.push(column)
            } else if (uniquePropertyTypes.length > 1 && uniquePropertyTypes.includes('Student Housing') && column.fieldName === 'unitMarketRent' && column.fieldName !== 'mrBed') {
                modifiedColumnList.push({ label: 'mixedWTAvg', summaryFieldName: '', summaryHeader: '(wt avg)', fieldName: 'mixedWTAvg' })
            } else if (uniquePropertyTypes.length > 1 && uniquePropertyTypes.includes('Student Housing') && column.fieldName !== 'unitMarketRent' && column.fieldName !== 'mrBed' && column.fieldName !== 'nonbeds' && column.fieldName !== 'beds') {
                modifiedColumnList.push(column)
            } else if (uniquePropertyTypes.length > 1 && uniquePropertyTypes.includes('Student Housing') && column.fieldName === 'nonbeds') {
                modifiedColumnList.push({ label: 'mixedWTAvg', summaryFieldName: '', summaryHeader: '(total)', fieldName: 'mixedWTAvg' })
            }
        })
        setFilteredColumnsList(modifiedColumnList)
    }


    const calcFloorPlanSummary = () => {
        let fpSummaryValue = []
        let propertyTypelist = []
        // console.log('propertyList = ', propertyList)
        FPUnitTypes.forEach(FPUnitType => {
            let totalUnitsByFP = 0, totalRFSByFP = 0, totalMRByFP = 0, totalERByFP = 0, totalBedsByFP = 0
            getCompsList().forEach(element => {
                if (!element.excludeProperty && element.data.omniviewproperty[0] && element.data.omniviewproperty[0].omniViewPropertyType) {
                    propertyTypelist.push(element.data.omniviewproperty[0].omniViewPropertyType)
                }

                if (!element.isSubjectProperty && !element.excludeProperty && element.data.omniviewpropertyrent) {

                    let rentData = element.data.omniviewpropertyrent.filter(x => x.source === element.data.omniviewproperty[0].source)
                    rentData = rentData.filter(x => x.unitType.includes(FPUnitType))

                    if (FPUnitType.toLowerCase() === '0 bedroom') {
                        rentData = rentData.filter(x => x.unitType.includes(FPUnitType) || x.unitType.includes('Studio'))
                    }

                    rentData.forEach(rentRow => {
                        totalUnitsByFP += +rentRow.units
                        totalBedsByFP += +rentRow.beds
                        totalRFSByFP += +rentRow.trsf
                        totalMRByFP += +rentRow.totalRent
                        totalERByFP += +(rentRow.unitEffectiveRent * rentRow.units) //totalEffectiveRent
                    });

                }

            })

            fpSummaryValue.push({
                unitType: FPUnitType,
                units: totalUnitsByFP,
                beds: totalBedsByFP,
                unitSize: unitsTotalFormula(totalRFSByFP, totalUnitsByFP),
                unitMarketRent: unitsTotalFormula(totalMRByFP, totalUnitsByFP),
                mrBed: unitsTotalFormula(totalMRByFP, totalBedsByFP),
                marketRentPerSF: unitsTotalFormula(totalMRByFP, totalRFSByFP),
                effectiveRent: unitsTotalFormula(totalERByFP, totalUnitsByFP),
                effectiveRentPerSF: unitsTotalFormula(totalERByFP, totalRFSByFP),
            })
        });
        setFloorplanSummaryValue(fpSummaryValue)
        setPropertyTypesArray(propertyTypelist)
    }

    return (
        <>
            {propertyList ?
                <TableContainer component={Paper}>
                    <Table id="tblpropertylist" aria-label="collapsible table" >
                        {propertyListView === 'floorplan' ?
                            <TableHead className="">
                                <TableRow>
                                    <TableCell className="sticky-left bg-gray-10" colSpan={1}>
                                    </TableCell>
                                    {FPUnitTypes.map(FPUnitType => (
                                        <TableCell align="center" colSpan={getColSpanForFP()} className="border-0 border-base border-r-1 border-b-1 bg-white">
                                            {/* {FPUnitType} */}
                                            {FPUnitType === '0 Bedroom' ? 'Studio' : FPUnitType}
                                        </TableCell>
                                    ))}

                                    <TableCell className="bg-gray-10" colSpan={2}></TableCell>
                                    <TableCell className="sticky-right bg-gray-10" colSpan={1}></TableCell>
                                </TableRow>
                            </TableHead>
                            : null}

                        <TableBody>
                            {getCompsList().map((row, index) => (
                                propertyListView === 'floorplan' ?
                                    <FloorPlanRow rowIndex={getRowIndex(row, index)} FPUnitTypes={FPUnitTypes}
                                        key={row.omniViewPropertyId} row={row} showAllDetails={showAllDetails} propertyTypesArray={propertyTypesArray}
                                        columnsList={columnsList} compType={getCompType()} colSpan={getColSpanForFP()} deleteList={deleteList} setDeleteList={setDeleteList} isStudentHousingProperty={isStudentHousingProperty} />
                                    : <Row rowIndex={getRowIndex(row, index)}
                                        key={row.omniViewPropertyId} row={row} showAllDetails={showAllDetails}
                                        columnsList={columnsList} compType={getCompType()} deleteList={deleteList} setDeleteList={setDeleteList} isStudentHousingProperty={isStudentHousingProperty} />
                            ))}

                            {/* summary row below */}
                            {propertyListView === 'overview' ?
                                <TableRow className="">
                                    {columnsList.map(column => (
                                        <TableCell className={`text-1 ${column.fieldName === 'propertyName' ? 'sticky-left' : ''}`} align={getAlignment(column.type)}>
                                            {column.summaryHeader !== '-' ?
                                                <>
                                                    <div className="flex flex-col">
                                                        <span> <strong>{getFieldValue(column)}</strong> </span>
                                                        <span className="text-1 truncate text-muted">{column.summaryHeader}</span>
                                                    </div>
                                                </>
                                                : null
                                            }
                                        </TableCell>
                                    ))}
                                    <TableCell className="sticky-right">

                                    </TableCell>
                                </TableRow>

                                : null}

                            {/* floorplan summary */}
                            {propertyListView === 'floorplan' ? <TableRow className="">
                                {filteredColumnsList.map(column => (
                                    <TableCell className={`text-1 ${column.fieldName === 'propertyName' ? 'sticky-left' : ''}`} align={getAlignment(column.type)}>
                                        {column.summaryHeader !== '-' ?
                                            <>
                                                <div className="flex flex-col">
                                                    <span> <strong>{getFloorPlanSummaryValue(column)}</strong> </span>
                                                    <span className="text-1 truncate text-muted">{column.summaryHeader}</span>
                                                </div>
                                            </>
                                            : null
                                        }
                                    </TableCell>
                                ))}
                                <TableCell className="sticky-right">

                                </TableCell>
                            </TableRow>

                                : null}
                        </TableBody>
                    </Table>
                </TableContainer>
                : null}
        </>
    )
}

export default CollapsibleTable

CollapsibleTable.propTypes = {
    setlstDetailsbtn: PropTypes.any
}
